import { useBrPageContext } from "../../context/context/context.js";
import { getUrl } from "../../utils/utils/get-url.js";
function useBloomreachRichText(html) {
  const page = useBrPageContext();
  if (html) {
    return html.replace(/<a href="([^"]*)"/g, (_, $1) => {
      return `<a href="${getUrl($1, page)}"`;
    });
  }
  return "";
}
export {
  useBloomreachRichText
};
//# sourceMappingURL=use-bloomreach-rich-text.js.map
